import { Box } from "@mui/system"
import { Outlet } from "react-router-dom"
import { Header } from "./header"

export const PrivateSectionLayout = () => {
  return (
    <Box className="private-layout-root" sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <Box className="private-layout-content" sx={{ display: 'flex', flexGrow: 1 }}>
        <Outlet />
      </Box>
    </Box>
  )
}